// @flow
import styled, { css } from "styled-components";
import { media } from "@nested/ui";

export const NavButton = styled.li`
  font-weight: ${({ theme }) => theme.typography.bold};
  font-size: 14px;
  color: ${({ colour, theme }) =>
    colour ? theme.palette[colour].medium : "white"};
  text-transform: uppercase;
  position: relative;
  letter-spacing: 1px;
  text-align: center;
  transition: all 0.2s ease;
  background-color: ${({ theme }) => theme.palette.navy.medium};
  border-radius: 100px;
  float: right;

  display: none;

  &:hover {
    transform: translateY(-2px);
  }
  &:active {
    transform: translateY(1px);
  }

  ${media.tablet`
    display: inline;
    height: 50px;
    width: 100px;
  `};

  /*
   * Menu buttons never appear on mobile. hide is set to remove them from bigger screens.
   * For example, a menu button with hide="lg" is hidden until md (the mobile breakpoint), then shown
   * between md and lg, and then hidden from lg and above.
   */
  ${({ hide }) =>
    hide &&
    css`
      @media (min-width: ${hide / 16}em) {
        display: none;
      }
    `};

  & > a {
    text-transform: inherit;
    color: inherit;
    font-weight: inherit;
    font-size: inherit;
    letter-spacing: inherit;
    line-height: inherit;
    text-decoration: none;
    display: block;
    margin: 0;
    line-height: 50px;
  }
`;
